'use client';

import { c as _c } from "react/compiler-runtime";
import { type CSSProperties, useMemo } from 'react';
import type { ResponsiveColumns } from './types';
function rowsInColumn(itemCount: number, columnCount: number) {
  const columns = Math.max(1, columnCount);
  return Math.max(1, Math.ceil(itemCount / columns));
}

/** Row counts keep each item in a fixed cell. CSS media queries choose which count is active. */
export function useFaqColumns(itemCount, columns) {
  const $ = _c(9);
  let t0;
  bb0: {
    if (!columns) {
      t0 = undefined;
      break bb0;
    }
    let t1;
    if ($[0] !== columns.tablet || $[1] !== itemCount) {
      t1 = rowsInColumn(itemCount, columns.tablet);
      $[0] = columns.tablet;
      $[1] = itemCount;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== columns.desktop || $[4] !== itemCount) {
      t2 = rowsInColumn(itemCount, columns.desktop);
      $[3] = columns.desktop;
      $[4] = itemCount;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
      t3 = {
        "--faq-rows-tablet": t1,
        "--faq-rows-desktop": t2
      };
      $[6] = t1;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t0 = t3 as CSSProperties;
  }
  return t0;
}